/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    YearlyRatiosDto,
    YearlyRatiosDtoFromJSON,
    YearlyRatiosDtoFromJSONTyped,
    YearlyRatiosDtoToJSON,
} from './YearlyRatiosDto';
import {
    YearlyRatiosEntryDto,
    YearlyRatiosEntryDtoFromJSON,
    YearlyRatiosEntryDtoFromJSONTyped,
    YearlyRatiosEntryDtoToJSON,
} from './YearlyRatiosEntryDto';

/**
 * 
 * @export
 * @interface SymbolFundamentalsRatiosHistoryDto
 */
export interface SymbolFundamentalsRatiosHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof SymbolFundamentalsRatiosHistoryDto
     */
    symbolId: string;
    /**
     * 
     * @type {Array<YearlyRatiosEntryDto>}
     * @memberof SymbolFundamentalsRatiosHistoryDto
     */
    yearly: Array<YearlyRatiosEntryDto>;
    /**
     * 
     * @type {YearlyRatiosDto}
     * @memberof SymbolFundamentalsRatiosHistoryDto
     */
    average5y: YearlyRatiosDto;
}

export function SymbolFundamentalsRatiosHistoryDtoFromJSON(json: any): SymbolFundamentalsRatiosHistoryDto {
    return SymbolFundamentalsRatiosHistoryDtoFromJSONTyped(json, false);
}

export function SymbolFundamentalsRatiosHistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SymbolFundamentalsRatiosHistoryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'symbolId': json['symbolId'],
        'yearly': ((json['yearly'] as Array<any>).map(YearlyRatiosEntryDtoFromJSON)),
        'average5y': YearlyRatiosDtoFromJSON(json['average5y']),
    };
}

export function SymbolFundamentalsRatiosHistoryDtoToJSON(value?: SymbolFundamentalsRatiosHistoryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'symbolId': value.symbolId,
        'yearly': ((value.yearly as Array<any>).map(YearlyRatiosEntryDtoToJSON)),
        'average5y': YearlyRatiosDtoToJSON(value.average5y),
    };
}

